var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nav'),_c('Kv'),_c('Beauty3d'),_c('Component21')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }